import React, { useState } from 'react';
import PageHeader from '../components/PageHeader';

const FAQ = () => {
  const [activeFAQ, setActiveFAQ] = useState(null);

  const faqs = [
    {
      id: 'faq1',
      question: 'What Services Do Your IT Company Offer?',
      answer: 'We offer a wide range of IT services, including software development, mobile app development, IT consulting, cybersecurity solutions, cloud services, and digital transformation.'
    },
    {
      id: 'faq2',
      question: 'What Technologies Do You Work With?',
      answer: 'We work with modern technologies including cloud platforms, AI/ML frameworks, various programming languages, and enterprise solutions.'
    },
    {
      id: 'faq3',
      question: 'How Experienced Is Your Team?',
      answer: 'Our team consists of highly experienced professionals with decades of combined experience in various industries and technologies.'
    },
    {
      id: 'faq4',
      question: 'What Technologies Do You Work With?',
      answer: 'We specialize in cutting-edge technologies and adapt to the latest industry standards to deliver optimal solutions.'
    },
    {
      id: 'faq5',
      question: 'How Do You Ensure The Security Of Our Data & Systems?',
      answer: 'We implement comprehensive security measures including encryption, secure development practices, and compliance with industry standards.'
    },
    {
      id: 'faq6',
      question: 'What Is Your Approach To Project Management?',
      answer: 'We follow agile methodologies and maintain transparent communication throughout the project lifecycle to ensure successful delivery.'
    }
  ];

  const toggleFAQ = (faqId) => {
    setActiveFAQ(activeFAQ === faqId ? null : faqId);
  };

  return (
    <div>
      <PageHeader 
        title="FAQ"
        subtitle="Frequently Asked Questions"
        backgroundImage="/images/FAQbg.png"
      />
      <div className="page-content">
        <div className="container">
          <div className="faq-container">
            <div>
              {faqs.map((faq) => (
                <div key={faq.id} className="faq-item">
                  <button 
                    className="faq-question" 
                    onClick={() => toggleFAQ(faq.id)}
                  >
                    {faq.question}
                    <span className="chevron">{activeFAQ === faq.id ? '▼' : '▶'}</span>
                  </button>
                  <div className={`faq-answer ${activeFAQ === faq.id ? 'active' : ''}`}>
                    <p>{faq.answer}</p>
                  </div>
                </div>
              ))}
            </div>
                    <div className="faq-image">
                      <img src="/images/What.png" alt="Professional team working on solutions" />
                    </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ; 